export enum GetSpreedlyCredentialsResponseType {
    Success = "Success",
    Failure = "Failure",
}

export interface GetSpreedlyCredentialsResponse {
    GetSpreedlyCredentialsResponse: GetSpreedlyCredentialsResponseType;
}

export interface GetSpreedlyCredentialsSuccessResponse extends GetSpreedlyCredentialsResponse {
    timestamp: string;
    nonce: string;
    certificateToken: string;
    signature: string;
}

export interface GetSpreedlyCredentialsFailureResponse extends GetSpreedlyCredentialsResponse {
    failureReason?: string;
}
